import type { AssetPlan } from '#/graphql/types';
import type { ColumnProps } from '#/common/components/DataGrid';
import { gql } from '@apollo/react-hooks';
import { withChip } from '#/common/utils/wrappers';
import { getTenantList } from '#/graphql/queries';
import { assetPlanStatusColors, assetPlanStatusItems } from '../../utils/constants';

const columns: ColumnProps<AssetPlan>[] = [
  { dataField: 'id', caption: 'ID', visible: false, showInColumnChooser: false },
  {
    dataField: 'displayNumber',
    caption: 'Number',
    visible: true,
    openOnClick: true,
    path: (row) => `/asset-plans/${row.id}/items`,
    fixed: true,
    dataType: 'string',
    sortIndex: 0,
    sortOrder: 'desc',
  },
  {
    dataField: 'name',
    caption: 'Name',
    visible: true,
    openOnClick: true,
    dataType: 'string',
  },
  {
    dataField: 'status',
    caption: 'Status',
    visible: true,
    dataType: 'string',
    lookup: {
      nullable: true,
      dataSource: assetPlanStatusItems,
      displayExpr: 'label',
      valueExpr: 'key',
    },
    cellRender: (e) => {
      if (!e.value) {
        return null;
      }

      const customColors = assetPlanStatusColors[e.value as string];
      return withChip(e.displayValue || '', 'normal', customColors);
    },
  },
  {
    dataField: 'tenant.name',
    caption: 'Organization',
    visible: true,
    dataType: 'string',
    headerFilter: {
      getItemList: gql(getTenantList),
      displayExpr: 'name',
    },
  },
  {
    dataField: 'startYear',
    caption: 'Start Year',
    visible: true,
    dataType: 'number',
  },
  {
    dataField: 'endYear',
    caption: 'End Year',
    visible: true,
    dataType: 'number',
  },
  {
    dataField: 'notes',
    caption: 'Notes',
    visible: true,
    dataType: 'string',
  },
  {
    dataField: 'createdAt',
    caption: 'Created At',
    visible: false,
    dataType: 'datetime',
  },
  {
    dataField: 'createdByUser.name',
    caption: 'Created By',
    visible: false,
    allowSorting: false,
    dataType: 'string',
  },
  {
    dataField: 'updatedAt',
    caption: 'Updated At',
    visible: false,
    dataType: 'datetime',
  },
  {
    dataField: 'updatedBy',
    caption: 'Updated By',
    visible: false,
    dataType: 'string',
  },
];

export default columns;
